import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'column',
    height: 185,
    margin: theme.spacing(5, 0),
    backgroundColor: '#ffffff',
    justifyContent: 'space-between',
    [theme.breakpoints.up('lg')]: {
      width: '93%'
    }
  },
  mainContainer: {
    textDecoration: 'none'
  },
  headerContainer: {
    backgroundColor: theme.palette.primary.main,
    width: '100%',
    height: 60,
    display: 'flex',
    alignItems: 'center'
  },
  titleContainer: {
    paddingLeft: theme.spacing(),
    width: '80%'
  },
  bodyContainer: {
    display: 'flex',
    height: 30,
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '85%',
    margin: '10px auto'
  },
  imageContainer: {
    width: 60,
    height: 60,
    borderRadius: 50,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    flexShrink: 0,
    marginRight: 6,
    marginLeft: -25,
    [theme.breakpoints.up('lg')]: {
      borderRadius: 80,
      width: 60,
      height: 60
    }
  },
  informationContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  title: {
    color: theme.palette.primary.contrastText,
    fontSize: '.9em',
    fontWeight: 600,
    overflowWrap: 'anywhere',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.up('lg')]: {
      fontSize: '1em'
    }
  },
  username: {
    color: theme.palette.primary.contrastText,
    fontSize: '.9em',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.up('lg')]: {
      fontSize: '1em'
    }
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.8em',
    paddingTop: 4,
    paddingRight: theme.spacing(),
    '& p': {
      textTransform: 'none',
      fontSize: '0.8rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      color: '#696969',
      WebkitBoxOrient: 'vertical'
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '.9em'
    }
  },
  sports: {
    display: 'flex',
    color: theme.palette.grey[500],
    fontSize: '.8em',
    textTransform: 'uppercase'
  },
  sport: {
    paddingRight: 2,
    color: '#696969'
  },

  followers: {
    marginTop: theme.spacing(),
    marginLeft: theme.spacing(0.5),
    color: '#696969',
    fontSize: '.625rem'
  },

  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '85%',
    justifyContent: 'space-between',
    margin: '10px auto'
  },

  actionButton: {
    textTransform: 'none',
    width: 80,
    height: 20,
    '& span': {
      fontSize: '0.725rem'
    }
  },
  profileLink: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: '.725rem'
  },
  actionContainer: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-around',
    alignItems: 'center'
  }
}))

export default useStyles
